import Vue from 'vue';
import http from '../utils/http';

export default {
    state: {
        resources: [],
        resources_team: null,
    },
    mutations: {
        loadResources(state, payload) {
			state.resources = payload;
		},
        loadTeamResources(state, payload) {
			state.resources_team = payload;
		},
        addResource(state, payload) {
            let index = state.resources.length
			Vue.set(state.resources, index, payload)   
        },
        updateResource(state, payload) {
            const toUpdate = state.resources?.find((res) => res.id == payload.id)
            if (toUpdate) {
                const index = state.resources.indexOf(toUpdate);
                Vue.set(state.resources, index, {... toUpdate, ...payload })
            } 
        },
        updateTeamResource(state, payload) {
            const toUpdate = state.resources_team?.find((res) => res.id == payload.id)
            if (toUpdate) {
                const index = state.resources_team.indexOf(toUpdate);
                Vue.set(state.resources_team, index, {... toUpdate, ...payload })
            } 
        },
        deleteResource(state, payload) {
            state.resources =  state.resources.filter(item => item.id !== payload)
        }
    },
    actions: {
        //fetch all resources by game id & round
        async fetchResources({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/resource/game/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const resources = await result.data 
                   commit('loadResources', resources)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //fetch team resources by game id & round
        async fetchTeamResources({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            const teamId = payload.teamId;
            const gameId = payload.gameId;
            const round = payload.round;
            
            try {
                const result = await http.get(`/resource/team/${teamId}?gameId=${gameId}&round=${round}`);
                if (result) {
                   const resources = await result.data 
                   commit('loadTeamResources', resources)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addResource({ commit }, payload) {
            commit('clearError')
			commit('setLoading', true)

            const team = payload.team;
            delete payload.team;
            payload.teamId = team.id;

            try {
                const result = await http.post(`/resource`, payload);
                
                if (result) {
                   const resource = await result.data; 
                   resource.team = team;
                   commit('addResource', resource);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async updateResource({ commit }, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                await http.put(`/resource/${payload.id}`, payload);
                commit('updateResource', payload);                             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async updateTeamResource({ commit }, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                await http.put(`/resource/${payload.id}`, payload);
                commit('updateTeamResource', payload);                             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async deleteResource({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/resource/${payload}`);
                commit('deleteResource', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async resourcesTransition({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                await http.get(`/resource/transition/${payload.gameId}?round=${payload.round}`);
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
    },
    getters: {
        resources (state) {
            return state.resources;
        },
        resources_team (state) {
            return state.resources_team;
        }
    }
}